export const config = {
    apiKey: "AIzaSyDFJzfSu0Xaad9w3_qqjAJCqZ2vbGllU_A",
    authDomain: "covid-aware-301221.firebaseapp.com",
    databaseURL: "https://covid-aware-301221-default-rtdb.firebaseio.com/",
    projectId: "covid-aware-301221",
    storageBucket: "covid-aware-301221.appspot.com",
    messagingSenderId: "568030616484",
    appId: "1:568030616484:web:2c229efcc2cb76b375ff31",
};
